exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-container{text-align:center}.chart-key-container{width:300px;margin:30px auto auto;padding:20px;border-radius:3px;border:1px solid #dde4e6}.circle{width:17.5px;height:17.5px;border-radius:50%;border:1px solid #dde4e6;display:inline-block;vertical-align:text-bottom}@media (min-width:992px){.nav-tabs .nav-item{-ms-flex-preferred-size:310px;flex-basis:310px}}", ""]);

// exports
